import { configureStore, combineReducers, AnyAction } from "@reduxjs/toolkit";
import userDataReducer, { extraTeams } from "./userSlice";
import projectDataReducer from "./projectSlice";
import testCaseDataSlice from "./testCaseSlice";
import billedPlanDataSlice from "./billedPlanSlice";
import serviceDataSlice from "./serviceSlice";
import subscriptionDataSlice from "./subscriptionSlice";

const combinedReducer = combineReducers({
  userData: userDataReducer,
  projectData: projectDataReducer,
  testCaseData: testCaseDataSlice,
  billedPlanData: billedPlanDataSlice,
  serviceData: serviceDataSlice,
  subscriptionData: subscriptionDataSlice,
});

const rootReducer = (
  state: ReturnType<typeof combinedReducer> | undefined,
  action: AnyAction
) => {
  let mutableState = state;
  if (action.type === "userData/storeLogout") {
    mutableState = {
      userData: {
        userId: undefined,
        email: undefined,
        userData: {},
        accounts: undefined,
        selectedAccount: undefined,
        selectedTeam: extraTeams[0],
      },
      projectData: { projects: [], selectedProject: undefined },
      testCaseData: { testCases: [], selectedTestCase: undefined },
      billedPlanData: { billedPlans: [], selectedBilledPlan: undefined },
      serviceData: {
        serviceList: [],
        servicesData: undefined,
        selectedService: undefined,
      },
      subscriptionData: {
        status: "loading",
        subscriptionId: null,
        trialEnd: null,
        isActive: false,
        isLoading: true,
        isInitialized: false,
        customerId: null,
      },
    };
  }
  return combinedReducer(mutableState, action);
};

const store = configureStore({
  reducer: rootReducer,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
